import { useEffect } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { ReportProblem } from "@material-ui/icons";

import UnauthorizedError from "./UnauthorizedError"
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#F2F2F2",
    width:'100%',
    height:'100%',
    boxSizing: 'border-box'
  },
  title: {
    fontSize: 20,
    marginBottom: 20
  },
  btn: {
    marginTop: 30
  }
}));

const clickHandler = () => {
  //ログイン済み=>top page、未ログイン=>login page
  window.location.reload();
};

function UnauthorizedErrorPage() {
  const {t} = useTranslation();
  const classes = useStyles();

  useEffect(() => {
    sessionStorage.removeItem('loggedIn');
  }, []);

  return (
    <div className={classes.root}>
      <ReportProblem fontSize="large" color="action"/>
      <h2 className={classes.title}>{t("Authentication Error")}</h2>
      <div>{t("Authentication has been disabled.")}</div>
      <div>{t("It's possible that two weeks have passed since your last login.")}</div>
      <div>{t("Please log in again.")}</div>
      <Button className={classes.btn} variant="contained" color="primary" onClick={() => clickHandler(true)}>TOP PAGE</Button>
    </div>
  );
}

function ErrorPage({error}) {
  const isUnauthorizedError = error instanceof UnauthorizedError;
  const classes = useStyles();
  return (
    <>
    {isUnauthorizedError && <UnauthorizedErrorPage/>}
    {!isUnauthorizedError &&
    <div className={classes.root}>
      <ReportProblem fontSize="large" color="action"/>
      <h2 className={classes.title}>System Error.</h2>
      <Button className={classes.btn} variant="contained" color="primary" onClick={clickHandler}>TOP PAGE</Button>
    </div>}
    </>
  );
}

export default ErrorPage;